'use strict';

angular.module('mean.users').factory('MeanUser', [ '$rootScope', 'tradeCodeService', '$http', '$location', '$stateParams', '$cookies', '$q', '$timeout', '$cookieStore', 'ngDialog', '$window',
  function($rootScope, tradeCodeService, $http, $location, $stateParams, $cookies, $q, $timeout, $cookieStore, ngDialog, $window) {
    var self;
    function escape(html) {
      return String(html)
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    }
    function b64_to_utf8( str ) {
      return decodeURIComponent(escape(window.atob( str )));
    }

    /*function url_base64_decode(str) {
      var output = str.replace('-', '+').replace('_', '/');
      switch (output.length % 4) {
      case 0:
      break;
      case 2:
      output += '==';
      break;
      case 3:
      output += '=';
      break;
      default:
      throw 'Illegal base64url string!';
      }
      return window.atob(output); //polifyll https://github.com/davidchambers/Base64.js
    }*/
    function MeanUserKlass(){
      this.name = 'users';
      this.user = {};
      this.registerForm = false;
      this.loggedin = false;
      this.isAdmin = false;
      this.loginError = 0;
      this.usernameError = null;
      this.registerError = null;
      this.resetpassworderror = null;
      this.validationError = null;
      $http.get('/api/users/me').success(this.onIdentity.bind(this));
      self = this;
    }

    MeanUserKlass.prototype.onIdentity = function(response) {
      console.log('in onIdentity');
      console.log(response);
      this.loginError = 0;
      this.loggedin = true;
      this.registerError = 0;
      if (!response) {
        this.user = {};
        this.loggedin = false;
        this.isAdmin = false;
        $window.user_role = '';
        $window.pts_username = null;
      } else if(angular.isDefined(response.token)) {
        localStorage.setItem('JWT', response.token);
        tradeCodeService.updateTrades();
        var encodedProfile = decodeURI(b64_to_utf8(response.token.split('.')[1]));
        const payload = JSON.parse(encodedProfile);
        this.user = payload;
        var destination = $cookies.redirect;
        if (this.user.roles.indexOf('admin') !== -1) this.isAdmin = true;
        $window.user_role = this.user.roles[0];
        $window.pts_username = this.user.username;
        if(this.user.need_password_reset) {
          $location.url('/password/reset');
        } else {
          $rootScope.$emit('loggedin');
          if (destination) {
            $location.path(destination.replace(/^"|"$/g, ''));
            $cookieStore.remove('redirect');
          } else {
            $location.url('/');
          }
        }
      } else {
        if(response.user) {
          $window.user_role = response.user.roles[0];
          $window.pts_username = response.user.username;
          this.user = response.user;
        } else {
          $window.user_role = response.roles[0];
          $window.pts_username = response.username;
          this.user = response;
        }
        this.loggedin = true;
        // laod trade names
        tradeCodeService.updateTrades();
        if(this.user.roles)
          if (this.user.roles.indexOf('admin') !== -1) this.isAdmin = true;
        if(this.user.user)
          if (this.user.user.roles.indexOf('admin') !== -1) this.isAdmin = true;

        // if(this.user.need_password_reset) {
        //   $location.url('/password/reset');
        // } else {
          $rootScope.$emit('loggedin');
        //}
      }
    };

    MeanUserKlass.prototype.onIdFail = function (response) {
      console.log(response);
      if(response !== "User needs to reset password") {
        $location.path(response.redirect);
        this.loginError = 'Authentication failed.';
        this.registerError = response;
        this.validationError = response.msg;
        this.resetpassworderror = response.msg;
        $rootScope.$emit('loginfailed', this);
        $rootScope.$emit('registerfailed');
      } else {
        $location.path('reset-password');
        // ngDialog.openConfirm({
        //   template: 'users/views/reset-password.html',
        //   //scope: self,
        //   className: 'ngdialog-theme-default'
        // }).then(function (value) {
        //   console.log(this);
        //   console.log(self);
        //   //MeanUser.resetpassword(this.user);
        // }, function (value) {
        //   //Do something
        //   console.log('in the do something section');
        // });
      }
    };

    var MeanUser = new MeanUserKlass();

    MeanUserKlass.prototype.login = function (user) {
      console.log(user);
      // this is an ugly hack due to mean-admin needs
      var destination = $location.path().indexOf('/login') === -1 ? $location.absUrl() : false;
      $http.post('/api/login', {
          username: user.username,
          password: user.password,
          redirect: destination
        })
        .success(this.onIdentity.bind(this))
        .error(this.onIdFail.bind(this));
    };

    MeanUserKlass.prototype.verify = function (user) {
      console.log(user);
      
      $http.post('/api/verify', {
          username: user.username,
          password: user.password,
          type: user.type
        })
        .success(function(success) {
          console.log('this was a successful validation of the user' + success);
          if(success.type === 'DailyReportVerification')
            $rootScope.$emit('userVerified', success.user);
          else if(success.type === 'TimeCardVerification')
            $rootScope.$emit('userVerifiedTC', success.user);
          else if(success.type === 'TimeCardSignVerification')
            $rootScope.$emit('userVerifiedTCSign', success.user);
        })
        .error(function(error) {
          console.log('The validation of this user was not successful' + error);
          $rootScope.$emit('verifyfailed', error);
        });
    };

    MeanUserKlass.prototype.verifyguest = function (user) {
      console.log(user);
      
      $http.post('/api/verifyguest', {
          username: user.username,
          password: user.password,
          type: user.type
        })
        .success(function(success) {
          if(success == 'Password incorrect') {
            $rootScope.$emit('verifyfailed', user);
          } else {
            console.log('this was a successful validation of the user - ' + success);
            if(success.type === 'DailyReportVerification')
              $rootScope.$emit('userVerified', success.user);
            else if(success.type === 'TimeCardVerification')
              $rootScope.$emit('userVerifiedTC', success.user);
            else if(success.type === 'TimeCardSignVerification')
              $rootScope.$emit('userVerifiedTCSign', success.user);
          }
        })
        .error(function(error) {
          console.log('The validation of this user was not successful - ' + error);
          $rootScope.$emit('verifyfailed', error);
        });
    };

    MeanUserKlass.prototype.verifyuser = function (user) {
      console.log(user);
      
      $http.post('/api/verifyguest', {
          username: user.username,
          password: user.password,
          type: user.type
        })
        .success(function(success) {
          if(success == 'Password incorrect') {
            $rootScope.$emit('crewUserVerifyFailed', user);
          } else {
            console.log('this was a successful validation of the user - ' + success);
            success.user.hour = user.hour;
            $rootScope.$emit('crewUserVerified', success.user);
          }
        })
        .error(function(error) {
          console.log('The validation of this user was not successful - ' + error);
          $rootScope.$emit('crewUserVerifyFailed', error);
        });
    };

    MeanUserKlass.prototype.register = function(user) {
      $http.post('/api/register', {
        email: user.email,
        password: user.password,
        confirmPassword: user.confirmPassword,
        username: user.username,
        name: user.name
      })
        .success(this.onIdentity.bind(this))
        .error(this.onIdFail.bind(this));
    };

    MeanUserKlass.prototype.resetpassword = function(user) {
        $http.post('/api/reset/' + $stateParams.tokenId, {
          password: user.password,
          confirmPassword: user.confirmPassword
        })
          .success(this.onIdentity.bind(this))
          .error(this.onIdFail.bind(this));
      };

    MeanUserKlass.prototype.resetAuthorized = function(user) {
        $http.post('/api/resetAuth/' + MeanUser.user._id, {
          password: user.password,
          confirmPassword: user.confirmPassword,
          need_password_reset: user.need_password_reset,
          agreed_to_tos: user.tos_agreement
        })
          .success(this.onIdentity.bind(this.user))
          .error(this.onIdFail.bind(this.user));
      };

    MeanUserKlass.prototype.resetForUser = function(user) {
        $http.post('/api/resetAuth/' + user._id, {
          password: user.password,
          confirmPassword: user.confirmPassword
        })
          .success(this.onIdentity.bind(this.user))
          .error(this.onIdFail.bind(this.user));
      };

    MeanUserKlass.prototype.forgotpassword = function(user) {
        console.log(user);
        $http.post('/api/forgot-password', {
          text: user.username
        })
          .success(function(response) {
            $rootScope.$emit('forgotmailsent', response);
          })
          .error(this.onIdFail.bind(this));
      };

    MeanUserKlass.prototype.logout = function(){
      this.user = {};
      this.loggedin = false;
      this.isAdmin = false;

      $http.get('/api/logout').success(function(data) {
        localStorage.removeItem('JWT');
        $rootScope.$emit('logout');
      });
    };

    MeanUserKlass.prototype.checkLoggedin = function() {
     var deferred = $q.defer();

      // Make an AJAX call to check if the user is logged in
      $http.get('/api/loggedin').success(function(user) {
        // Authenticated
        if (user !== '0') $timeout(deferred.resolve);

        // Not Authenticated
        else {
          $cookieStore.put('redirect', $location.path());
          $timeout(deferred.reject);
          $location.url('/auth/login');
        }
      });

      return deferred.promise;
    };

    MeanUserKlass.prototype.checkLoggedOut = function() {
       // Check if the user is not connected
      // Initialize a new promise
      var deferred = $q.defer();

      // Make an AJAX call to check if the user is logged in
      $http.get('/api/loggedin').success(function(user) {
        // Authenticated
        if (user !== '0') {
          $timeout(deferred.reject);
          $location.url('/');
        }
        // Not Authenticated
        else $timeout(deferred.resolve);
      });

      return deferred.promise;
    }

    MeanUserKlass.prototype.checkAdmin = function() {
     var deferred = $q.defer();

      // Make an AJAX call to check if the user is logged in
      $http.get('/api/loggedin').success(function(user) {
        // Authenticated
        if (user !== '0' && user.roles.indexOf('admin') !== -1) $timeout(deferred.resolve);

        // Not Authenticated or not Admin
        else {
          $timeout(deferred.reject);
          $location.url('/');
        }
      });

      return deferred.promise;
    };

    //Temporary code
    var tokenWatch = $rootScope.$watch(function() { return $cookies.get('token'); }, function(newVal, oldVal) {
        if (newVal && newVal !== undefined && newVal !== null && newVal !== '') {
         self.onIdentity({token: $cookies.get('token')});
         $cookieStore.remove('token');
         tokenWatch();
        }
      });

    return MeanUser;
  }
]);



// WEBPACK FOOTER //
// ./packages/custom/users/public/services/meanUser.js